// React Imports
import * as React from 'react';
import {useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {FormHelperText, Input, InputLabel, Select, Tooltip} from "@mui/material";

// App Imports
import {addDataPointAttribute, editDataPointAttribute} from "./DataPointAttributeClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import {changeDataPointAttribute} from "./dataPointAttributeSlice";
import FormControl from "@mui/material/FormControl";
import {addUsers} from "../Users/UsersClient";
import MenuItem from "@mui/material/MenuItem";



// Main Function
export default function DataPointAttributeDrawer({ categoryDropdown }) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
;
    const selectorDataPointAttributeId = useSelector((state) => state.dataPointAttributeSlc.value.id);
    const selectorDataPointAttributeMcode = useSelector((state) => state.dataPointAttributeSlc.value.mcode);
    const selectorDataPointAttributeCategory = useSelector((state) => state.dataPointAttributeSlc.value.category);
    const selectorDpaDrawerState = useSelector((state) => state.dataPointAttributeSlc.value.dpaDrawerState);
    const selectorDpaDrawerMode = useSelector((state) => state.dataPointAttributeSlc.value.dpaDrawerMode);
    const drawerModeRef = React.useRef(selectorDpaDrawerMode);
    // ****************** END STORE ****************************

    const handleCategoryChange = (categoryEvent) => {
        // setSelectedCategory(categoryEvent.target.value);
        dispatchData(changeDataPointAttribute({category: categoryEvent.target.value}));
        console.log("This is for the selected Category");
        console.log(categoryEvent.target.value);
    };

    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my dataPointAttribute data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorDpaDrawerMode==="Add"){
            addDataPointAttribute(data)
                .then(() => {
                    console.log("DataPointAttribute added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPointAttribute({id: 0, mcode: "", name: "", description: "" , category: "",
                    dpaDrawerState: false, dpaGridRefresh: true}));
            })}
        if(selectorDpaDrawerMode==="Clone"){
                const { id, ...clonedData } = data; // removes id
            addDataPointAttribute(clonedData)
                .then(() => {
                    console.log("DataPointAttribute cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Clone added"}));
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Clone failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPointAttribute({id: 0, mcode: "", name: "", description: "" , category: "",
                    dpaDrawerState: false, dpaGridRefresh: true}));
            })}
        if(selectorDpaDrawerMode==="Edit"){
            console.log("This is the dataPointAttribute Id I am going to edit")
            console.log(selectorDataPointAttributeId)
            editDataPointAttribute(selectorDataPointAttributeId, data)
                .then(() => {
                    console.log("DataPointAttribute edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Clone failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPointAttribute({id: 0, mcode: "", name: "", description: "" , category: "",
                    dpaDrawerState: false, dpaGridRefresh: true}));
            })}
    };

    // ****************** END CRUD ****************************


    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    function closeDataPointAttributeDrawer() {
        // setShowDataPointAttributeDrawer(false);
        dispatchData(changeDataPointAttribute({id: null, mcode: null, name: null, description: null,
            status: null,category: null,
            dpaDrawerState: false}));

    };

    // ****************** END MISC ****************************


    // ****************** BEGIN FORM ****************************

    // function dataPointAttributeForm(){
    const dataPointAttributeForm = () => {
        return(

            <Box
                sx={{ width: 800 , height: 300, pl: 5}}
                role="presentation"
                key={selectorDataPointAttributeId}

            >
                <form
                    onSubmit={handleSubmit((data)=>        onSubmit(data))}>
                <h1 onClick={() => closeDataPointAttributeDrawer()}>Data Point Attribute Form</h1>
                <h4>{selectorDpaDrawerMode} Mode</h4>
                <br/>
                    <br/>
                    <br/>
                <FormControl>
                <InputLabel htmlFor="mcode">Code</InputLabel>
                <Input                    onLoad={()=>this.reset}
                    {...register('mcode', { required: true })}
                    defaultValue={useSelector((state) => state.dataPointAttributeSlc.value.mcode)}
                    contentEditable={true}
                    inputRef={null}
                />
                <FormHelperText id="mcode_helper">enter a brief code in all caps</FormHelperText>
                </FormControl>
                <br/>
                <br/>
                <br/>
                <InputLabel htmlFor="name">Name</InputLabel>
                <Input
                        defaultValue={useSelector((state) =>  state.dataPointAttributeSlc.value.name)}
                    {...register('name', { required: true })}
                    id="name"   name="name"  label="Name" aria-describedby="name_entry"
                    sx={{ width: 600 }} />
                <FormHelperText id="name_helper">enter the name of the Data Point Attribute</FormHelperText>

                <br/>
                <br/>
                <br/>
                <InputLabel htmlFor="description">Description</InputLabel>
                <Input
                    {...register('description', { required: false })}
                    id="description" name="description"  label="description" aria-describedby="description_entry"
                    defaultValue=        {useSelector((state) => state.dataPointAttributeSlc.value.description)}
                    sx={{ width: 700 }}/>
                <FormHelperText id="description_helper">enter a description of the Data Point Attribute</FormHelperText>
                <br/>
                <br/>
                    <br/>
                    {/*<InputLabel htmlFor="category">Category</InputLabel>*/}
                    {/*<Input*/}
                    {/*    {...register('category', { required: false })}*/}
                    {/*    id="category" name="category"  label="category" aria-describedby="category_entry"*/}
                    {/*    defaultValue=        {useSelector((state) => state.dataPointAttributeSlc.value.category)}*/}
                    {/*    sx={{ width: 700 }}/>*/}


                    <FormHelperText id="category_helper">select a category of the Data Point Attribute</FormHelperText>
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <Tooltip enterDelay={1000}
                                 title={"select a category for this attribute (optional)."}>
                            <InputLabel htmlFor="category">Category</InputLabel>
                        </Tooltip>
                        <Select
                            {...register('category', {required: false})}
                            labelId="demo-simple-select-filled-category"
                            id="category"
                            label="Category"
                            sx={{width: 300}}
                            onChange={handleCategoryChange}
                            value={useSelector((state) => state.dataPointAttributeSlc.value.category)}
                        >
                            {categoryDropdown.map((CategoryItem) =>
                                <MenuItem value={CategoryItem.name}>{CategoryItem.name}</MenuItem>
                            )}
                        </Select>
                        {/*<FormHelperText id="category_helper">select the folder into which this will go on new*/}
                        {/*    contracts</FormHelperText>*/}
                        </FormControl>

                    <br/>
                    <br/>
                    <br/>
                <Button
                    type="submit"
                >Submit</Button>
                <Button onClick={() => closeDataPointAttributeDrawer()}>Cancel</Button>
                </form>
            </Box>
            );};

    // ****************** END FORM ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorDpaDrawerState}
                initialState={{open: false}}
                onClose={closeDataPointAttributeDrawer}
            >
                {dataPointAttributeForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
